import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MuxSessionService } from 'src/app/services/mux-session.service';

@Component({
  selector: 'app-pins-pane',
  templateUrl: './pins-pane.component.html',
  styleUrls: ['./pins-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PinsPaneComponent {
  @Input() pinnedMessages: MuxSessionService.PinnedMessage[] = [];
  @Output() unpin = new EventEmitter<MuxSessionService.PinnedMessage>();
  @Output() seek = new EventEmitter<MuxSessionService.PinnedMessage>();
  @Output() close = new EventEmitter<void>();
  @Output() openFile = new EventEmitter<{ path: string; title: string }>();

  public isLongContent(content: string): boolean {
    return content && content.length > 400;
  }

  public hasToolCalls(content: string): boolean {
    if (!content || typeof content !== 'string') return false;
    if (content.includes('\x02TOOLJSON')) return true;
    if (/(?<!`)\[TOOL_START\]🔧 Tool:/.test(content)) return true;
    return false;
  }
}
